/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import Router from 'vue-router';
import service from './services';
import functions from './utils/functions';
import jwt from 'jsonwebtoken';
import ability from './services/ability';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      redirect: '/dashboard',
      beforeEnter: function (to, from, next) {
        isAuth(to, next);
        maintenance(next);
        verificaDominio(next);
      },
      component: () => import('./v2/PageLayout.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/dashboard',
          name: 'Dashboard',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: true,
          },
        },
        {
          path: '/veiculos',
          name: 'Veículos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/veiculos/:vehicleId/historico-de-observacoes',
          name: 'Veículos - Histórico de Observações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/veiculos/:vehicleId/historico-de-alteracoes',
          name: 'Veículos - Histórico de Alterações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/cadastro-bancario',
          name: 'Listagem',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/cadastro-bancario/analise-financeira',
          name: 'Análise de Contas',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/makemore/configuracao',
          name: 'Configurações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/makemore',
          name: 'Listagem Make More',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/carteira-distribuicao',
          name: 'Distribuição de Cobranças',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/corretagens',
          name: 'Listagem de Corretagem',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/corretagens/solicitacao',
          name: 'Solicitação de corretagem',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/fecha-bem/configuracoes',
          name: 'Configurações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/fecha-bem',
          name: 'Listagem',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/oficinas',
          name: 'Oficinas',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/oficinas/:id',
          name: 'Oficinas',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/eventos/listagem',
          name: 'Listagem de Eventos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/eventos/esteira-de-processos',
          name: 'Esteira de Processos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/eventos/configuracoes',
          name: 'Tipos de Arquivos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/eventos/monitoramento',
          name: 'Monitoramento de Eventos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/Associados',
          name: 'Associados',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/Associados.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Benefíciarios',
                active: true,
              },
            ],
            pageTitle: 'Benefíciarios',
            rule: 'editor',
          },
        },
        {
          path: '/DetalheAssociado/:idAssociado',
          name: 'DetalheAssociado',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/Associado-Detalhe.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Detalhes',
                active: true,
              },
            ],
            pageTitle: 'Detalhes do Benefíciario',
            checkPermission: false,
          },
        },
        {
          path: '/EditarAssociado/:idAssociado',
          name: 'EditarAssociado',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/editarAssociado.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Editar',
                active: true,
              },
            ],
            pageTitle: 'Editar dados do Beneficiário',
            checkPermission: false,
          },
        },
        {
          path: '/Cotacoes',
          name: 'Cotações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/Cotacoes.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Painel Propostas',
                active: true,
              },
            ],
            pageTitle: 'Painel Propostas',
            rule: 'editor',
          },
        },
        {
          path: '/CotacoesB2C',
          name: 'Cotações B2C',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/CotacoesB2C.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cotações Consultor Online',
                active: true,
              },
            ],
            pageTitle: 'Cotações  Consultor Online',
            rule: 'editor',
          },
        },
        {
          path: '/PainelLeadsB2C',
          name: 'Painel de Leads B2C',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/b2c/PainelLeadsB2CView.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Painel de Leads B2C',
                active: true,
              },
            ],
            pageTitle: 'Painel de Leads B2C',
            rule: 'editor',
          },
        },
        {
          path: '/novaProposta/Interno',
          name: 'novaProposta',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('@/views/pages/novaProposta.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Nova Proposta',
                active: true,
              },
            ],
            pageTitle: 'Nova Proposta',
            checkPermission: false,
          },
        },
        {
          path: '/novaProposta/multi-proposta',
          name: 'Proposta Múltipla',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import(
              './views/menu/propostas/multi-propostas/FormMultiProposta.vue'
            ),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Nova Proposta',
                url: '/novaProposta/Interno',
              },
              {
                title: 'Multi Proposta',
                active: true,
              },
            ],
            pageTitle: 'Multi Proposta',
            checkPermission: false,
            rule: 'editor',
          },
        },
        {
          path: '/novaPreCotacao',
          name: 'Pré Cotações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/forms/formPreCotacao.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Nova Pré-Cotação',
                active: true,
              },
            ],
            pageTitle: 'Nova Pré-Cotação',
            checkPermission: true,
          },
        },
        {
          path: '/cadastro-ranking',
          name: 'Ranking Cadastro',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
          },
          component: () =>
            import('./views/pages/RankingRegister/RankingRegisterView.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Ranking Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Ranking Cadastro',
          },
        },
        {
          path: '/fechamento',
          name: 'Fechamento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/financeiro/Fechamento/FechamentoView.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Financeiro',
              },
              {
                title: 'Fechamento',
                active: true,
              },
            ],
            pageTitle: 'Fechamento',
            rule: 'editor',
          },
        },
        {
          path: '/Extrato',
          name: 'Extrato',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/financeiro/Extrato.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Extrato',
                active: true,
              },
            ],
            pageTitle: 'Extrato',
            rule: 'editor',
          },
        },
        {
          path: '/PainelFinanceiro',
          name: 'Painel Financeiro',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/financeiro/PainelFinanceiro.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Painel Financeiro',
                active: true,
              },
            ],
            pageTitle: 'Painel Financeiro',
            rule: 'editor',
          },
        },
        {
          path: '/ArquivoRemessa',
          name: 'Arquivo Remessa',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/financeiro/arquivoRemessa.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Arquivo Remessa', active: true },
            ],
            pageTitle: 'Arquivo Remessa',
            rule: 'editor',
          },
        },
        {
          path: '/ArquivoRetorno',
          name: 'Arquivo Retorno',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/financeiro/arquivoRetorno.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Arquivo Retorno', active: true },
            ],
            pageTitle: 'Arquivo Retorno',
            rule: 'editor',
          },
        },
        {
          path: '/gestao-status',
          name: 'Gestão Status',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import(
              './views/menu/financeiro/Gestao-Status/GestaoStatusView.vue'
            ),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Gestão Status', active: true },
            ],
            pageTitle: 'Gestão Status',
            rule: 'editor',
          },
        },
        {
          path: '/pagamentos-inconsistentes',
          name: 'Pagamentos Inconsistentes',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import(
              './views/menu/financeiro/Pagamentos-Inconsistentes/PagamentosInconsistentesView.vue'
            ),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pagamentos Inconsistentes', active: true },
            ],
            pageTitle: 'Pagamentos Inconsistentes',
            rule: 'editor',
          },
        },
        {
          path: '/Ouvidoria',
          name: 'Ouvidoria',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/relacionamentos/Ouvidoria.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Ouvidoria',
                active: true,
              },
            ],
            pageTitle: 'Fale Conosco',
            rule: 'editor',
          },
        },
        {
          path: '/Cancelamentos',
          name: 'Cancelamentos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/relacionamentos/Cancelamentos.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cancelamentos',
                active: true,
              },
            ],
            pageTitle: 'Cancelamentos',
            rule: 'editor',
          },
        },
        {
          path: '/NovoCancelamento',
          name: 'NovoCancelamento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/relacionamentos/NovoCancelamento.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Novo Cancelamento',
                active: true,
              },
            ],
            pageTitle: 'Novo Cancelamento',
            checkPermission: false,
          },
        },
        {
          path: '/Checklist',
          name: 'Checklist',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/assistencia/checklist.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Checklist',
                active: true,
              },
            ],
            pageTitle: 'Checklist',
            rule: 'editor',
          },
        },
        {
          path: '/PreAberturaEvento',
          name: 'Eventos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/forms/formPreAberturaEvento.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Eventos',
                url: '/Eventos',
              },
              {
                title: 'Pré Abertura de Evento',
                active: true,
              },
            ],
            pageTitle: 'Pré Abertura de Evento',
            rule: 'editor',
          },
        },
        {
          path: '/NovoChecklist',
          name: 'Novo Checklist',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/forms/formDadosDoChecklist.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Novo Checklist',
                active: true,
              },
            ],
            pageTitle: 'Novo Checklist',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/EditarChecklist/:idChecklist',
          name: 'Editar Checklist',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/forms/formEditarDadosDoChecklist.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Editar Checklist',
                active: true,
              },
            ],
            pageTitle: 'Editar Checklist',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/Pre-Cotacoes',
          name: 'Pré Cotações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/PreCotacao.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Pré Cotações',
                active: true,
              },
            ],
            pageTitle: 'Pré Cotações',
            rule: 'editor',
          },
        },
        {
          path: '/DetalheCancelamento/:idCancelamento',
          name: 'DetalheCancelamento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/relacionamentos/ExibeCancelamento.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Detalhes',
                active: true,
              },
            ],
            pageTitle: 'Detalhes do Cancelamento',
            checkPermission: false,
          },
        },
        {
          path: '/EditarCancelamento/:idCancelamento',
          name: 'EditarCancelamento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/relacionamentos/NovoCancelamento.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Editarr',
                active: true,
              },
            ],
            pageTitle: 'Editar Cancelamento',
            checkPermission: false,
          },
        },
        {
          path: '/ChamadosInternos',
          name: 'Chamados Internos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/relacionamentos/ChamadosInternos.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Chamados Internos',
                active: true,
              },
            ],
            pageTitle: 'Chamados Internos',
            rule: 'editor',
          },
        },
        {
          path: '/Chamado',
          name: 'Fale com Especialista',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/Chamado.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Chamados com o Especialista',
                active: true,
              },
            ],
            pageTitle: 'Fale com o Especialista',
            rule: 'editor',
          },
        },
        {
          path: '/Vistorias',
          name: 'Vistorias',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/Vistorias.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Vistorias',
                active: true,
              },
            ],
            pageTitle: 'Vistorias',
            rule: 'editor',
          },
        },
        {
          path: '/eventos',
          name: 'Eventos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/eventos/Eventos-List/Eventos-List.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Painel Eventos',
                active: true,
              },
            ],
            pageTitle: 'Painel Eventos',
            rule: 'editor',
          },
        },
        {
          path: '/eventos/beta',
          name: 'Painel de Eventos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/SituacoesEvento',
          name: 'Situação de Evento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
          },
          component: () =>
            import(
              './views/menu/eventos/situacoes-evento/situacoes-evento-list.vue'
            ),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Eventos',
                url: '/eventos',
              },
              {
                title: 'Situação de Evento',
                active: true,
              },
            ],
            pageTitle: 'Situação de Evento',
            rule: 'editor',
            checkPermission: true,
          },
        },
        {
          path: '/MotivosEvento',
          name: 'Motivo de Evento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
          },
          component: () =>
            import(
              './views/menu/eventos/motivos-evento/motivos-evento-list.vue'
            ),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Eventos',
                url: '/eventos',
              },
              {
                title: 'Motivo de Evento',
                active: true,
              },
            ],
            pageTitle: 'Motivo de Evento',
            rule: 'editor',
            checkPermission: true,
          },
        },
        {
          path: '/detalheVistoria/:idCotacao',
          name: 'detalheVistoria',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/VistoriasDetalhes.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Vistorias',
                url: '/Vistorias',
              },
              {
                title: 'Detalhe',
                active: true,
              },
            ],
            pageTitle: 'Detalhe',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editarCotacao/:idCotacao',
          name: 'editarCotacao',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/editarCotacao2.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cotações',
                url: '/Cotacoes',
              },
              {
                title: 'Editar',
                active: true,
              },
            ],
            pageTitle: 'Editar',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editarCotacao2/:idCotacao',
          name: 'editarCotacao2',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/editarCotacao2.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cotações',
                url: '/Cotacoes',
              },
              {
                title: 'Editar',
                active: true,
              },
            ],
            pageTitle: 'Editar',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editarEvento/:idEvento',
          name: 'editarEvento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/editarEvento.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Eventos',
                url: '/eventos',
              },
              {
                title: 'Editar',
                active: true,
              },
            ],
            pageTitle: 'Editar',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editar-evento/:idEvento',
          name: 'editarEvento-v2',
          beforeEnter: function (to, from, next) {
            isAuth({ name: 'Eventos', meta: { checkPermission: true } }, next);
          },
          component: () =>
            import('./views/menu/eventos/Eventos/EditarEventoView.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Painel Eventos',
                url: '/eventos',
              },
              {
                title: 'Editar Eventos',
                active: true,
              },
            ],
            pageTitle: 'Editar Eventos',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editar-eventos-terceiro/:idEvento/:idTerceiro',
          name: 'editar-eventos-terceiro',
          beforeEnter: function (to, from, next) {
            // Atualiza a URL do breadcrumb com o parâmetro idEvento
            const breadcrumb = to.meta.breadcrumb;
            const idEvento = to.params.idEvento;

            breadcrumb[2].title = `Evento - ${idEvento}`;
            breadcrumb[2].url = `/editar-evento/${idEvento}`;

            isAuth({ name: 'Eventos', meta: { checkPermission: true } }, next);
          },
          component: () =>
            import(
              './views/menu/eventos/Eventos-Terceiros/EditarTerceirosView.vue'
            ),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Painel Eventos',
                url: '/eventos',
              },
              {
                title: 'Evento',
                url: '/editar-evento/:idEvento',
                active: true,
              },
              {
                title: 'Editar Terceiro',
                active: true,
              },
            ],
            pageTitle: 'Editar Terceiro',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editar-eventos-patrimonio/:idEvento/:idPatrimonio',
          name: 'editar-eventos-patrimonio',
          beforeEnter: function (to, from, next) {
            // Atualiza a URL do breadcrumb com o parâmetro idEvento
            const breadcrumb = to.meta.breadcrumb;
            const idEvento = to.params.idEvento;

            breadcrumb[2].title = `Evento - ${idEvento}`;
            breadcrumb[2].url = `/editar-evento/${idEvento}`;

            isAuth({ name: 'Eventos', meta: { checkPermission: true } }, next);
          },
          component: () =>
            import(
              './views/menu/eventos/Eventos-Patrimonio/EditarPatrimonioView.vue'
            ),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Painel Eventos',
                url: '/eventos',
              },
              {
                title: 'Evento',
                url: '/editar-evento/:idEvento',
                active: true,
              },
              {
                title: 'Editar Patrimônio',
                active: true,
              },
            ],
            pageTitle: 'Editar Patrimônio',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/evento-analise/:idEvento',
          name: 'Análise de Eventos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
          },
          component: () =>
            import(
              './views/menu/eventos/Eventos-Analise/EventosAnaliseView.vue'
            ),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Eventos',
                url: '/eventos',
              },
              {
                title: 'Análise do Evento',
                active: true,
              },
            ],
            pageTitle: 'Análise do Evento',
            rule: 'editor',
          },
        },
        {
          path: '/novo-evento',
          name: 'novo-evento',
          beforeEnter: function (to, from, next) {
            isAuth({ name: 'Eventos', meta: { checkPermission: true } }, next);
          },
          component: () =>
            import('./views/menu/eventos/Novo-Evento/NovoEventoView.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Painel Eventos',
                url: '/eventos',
              },
              {
                title: 'Novo Evento',
                active: true,
              },
            ],
            pageTitle: 'Novo Evento',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editarOuvidoria/:idOuvidoria',
          name: 'editarOuvidoria',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/relacionamentos/editarOuvidoria.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Ouvidorias',
                url: '/Ouvidoria',
              },
              {
                title: 'Editar',
                active: true,
              },
            ],
            pageTitle: 'Editar',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editarChamado/:idChamado',
          name: 'editarChamado',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/editarChamado.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Chamados',
                url: '/Chamado',
              },
              {
                title: 'Editar',
                active: true,
              },
            ],
            pageTitle: 'Editar',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/editarChamadoInterno/:idChamado',
          name: 'editarChamadoInterno',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/relacionamentos/editarChamadoInterno.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Chamados Internos',
                url: '/ChamadosInternos',
              },
              {
                title: 'Editar',
                active: true,
              },
            ],
            pageTitle: 'Editar',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/Graficos/Crescimento',
          name: 'Crescimento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/graficos/crescimento.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Relatórios',
                active: true,
              },
            ],
            pageTitle: 'Crescimento de Base',
            rule: 'editor',
          },
        },
        {
          path: '/Graficos/Vendas',
          name: 'Vendas',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/graficos/vendas.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Relatórios',
                active: true,
              },
            ],
            pageTitle: 'Vendas',
            rule: 'editor',
          },
        },
        {
          path: '/Graficos/Cancelamentos',
          name: 'Cancelamentos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/graficos/cancelamentos.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Relatórios',
                active: true,
              },
            ],
            pageTitle: 'Cancelamentos',
            rule: 'editor',
          },
        },
        {
          path: '/Consolidado',
          name: 'Consolidado',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
          },
          component: () => import('./views/menu/graficos/Consolidado.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Relatórios',
                active: true,
              },
            ],
            pageTitle: 'Painel de Vendas',
            rule: 'editor',
          },
        },
        {
          path: '/SuperRanking',
          name: 'Super Ranking',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
          },
          component: () =>
            import('./views/pages/PainelComercial/PainelComercialView.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Relatórios',
                active: true,
              },
            ],
            pageTitle: 'Super Ranking',
            rule: 'editor',
          },
        },
        {
          path: '/relatorio-rastreador',
          name: 'Relatório Rastreador',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/PodioAnual',
          name: 'Pódio Anual',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
          },
          component: () => import('./views/pages/PodioAnual/AnnualPodiumView'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Relatórios',
                active: true,
              },
            ],
            pageTitle: 'Pódio Anual',
            rule: 'editor',
          },
        },
        {
          path: '/Dinamicos',
          name: 'Dinamicos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import(
              './views/menu/relatorios/dinamicos/RelatoriosDinamicosView.vue'
            ),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Relatórios Dinâmicos',
                active: true,
              },
            ],
            pageTitle: 'Relatórios Dinâmicos',
            rule: 'editor',
          },
        },
        {
          path: '/Metas',
          name: 'Metas Por Regionais',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/metas/cadastro-metas.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Metas',
                url: '/metas',
              },
            ],
            pageTitle: 'Metas',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/Graficos/Criticas',
          name: 'Criticas',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/relatorios/Relatorios.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Graficos',
                active: true,
              },
            ],
            pageTitle: 'Criticas',
            rule: 'editor',
          },
        },
        {
          path: '/marketing/painel-de-leads',
          name: 'Painel de Leads',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
          },
          component: () =>
            import('./views/menu/marketing/painel-leads/PainelLeadsView.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Marketing',
                active: true,
              },
              {
                title: 'Painel de Leads',
                active: true,
              },
            ],
            pageTitle: 'Painel de Leads',
            rule: 'editor',
          },
        },
        // =============================================================================
        // MENU ADMINISTRADOR (CADASTRO)
        // =============================================================================
        {
          path: '/empresa',
          name: 'Empresa',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/empresa.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Empresa',
            rule: 'editor',
          },
        },
        {
          path: '/usuarios',
          name: 'Usuário',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/usuarios.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Usuários',
            rule: 'editor',
          },
        },
        {
          path: '/vistoriadores',
          name: 'Vistoriador',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/vistoriadores.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Vistoriador',
            rule: 'editor',
          },
        },
        {
          path: '/regionais',
          name: 'Regional',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/regionais.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Regionais',
            rule: 'editor',
          },
        },
        {
          path: '/divisoes',
          name: 'Divisão',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/divisoes.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Divisões',
            rule: 'editor',
          },
        },
        {
          path: '/setores',
          name: 'Setor',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/setores.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Setores',
            rule: 'editor',
          },
        },
        {
          path: '/tipoAtendimento',
          name: 'Tipo de Atendimento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/tipoAtendimento.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Tipo de Atendimento',
            rule: 'editor',
          },
        },
        {
          path: '/perfis',
          name: 'Perfil de Usuário',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/perfis.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Perfil de Usuário',
            rule: 'editor',
          },
        },
        {
          path: '/contasBancarias',
          name: 'Contas Bancárias',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/contasBancarias.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Contas Bancárias',
            rule: 'editor',
          },
        },
        {
          path: '/carteiraCobranca',
          name: 'Carteira de Cobrança',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/cadastros/carteirasCobranca.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Carteira de Cobrança',
            rule: 'editor',
          },
        },
        {
          path: '/permissoes',
          name: 'Permissões',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/permissoes.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Cadastro',
                active: true,
              },
            ],
            pageTitle: 'Permissões',
            rule: 'editor',
          },
        },
        {
          path: '/mensageria',
          name: 'Mensageria',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/cadastros/Mensageria/mensageria-list.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Mensageria',
                active: true,
              },
            ],
            pageTitle: 'Mensageria',
            rule: 'editor',
          },
        },
        {
          path: '/mensageria/novo',
          name: 'Mensageria',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/cadastros/Mensageria/mensageria-form.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Mensageria  ',
                url: '/mensageria',
              },
              {
                title: 'Cadastro Mensagem',
                active: true,
              },
            ],
            pageTitle: 'Cadastro Mensagem',
            rule: 'editor',
          },
        },
        {
          path: '/mensageria/editar/:idMensagem',
          name: 'Mensageria',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/cadastros/Mensageria/mensageria-form.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Mensageria',
                url: '/mensageria',
              },
              {
                title: 'Edição Mensagem',
                active: true,
              },
            ],
            pageTitle: 'Edição Mensagem',
            rule: 'editor',
          },
        },
        {
          path: '/programaAfiliados',
          name: 'Programa de Afiliados',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/cadastros/programaAfiliados.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Programa de Afiliados',
                active: true,
              },
            ],
            pageTitle: 'Programa de Afiliados',
            rule: 'editor',
          },
        },
        {
          path: '/programaAfiliadosMetas/:id',
          name: 'Programa de Afiliados',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/tabelas/programaAfiliadosMetas.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Programa de Afiliados',
                url: '/programaAfiliados',
              },
              {
                title: 'Metas por Programa de Afiliados',
                active: true,
              },
            ],
            pageTitle: 'Metas por Programa de Afiliados',
            // checkPermission: true,
            rule: 'editor',
          },
        },
        {
          path: '/fornecedor',
          name: 'Fornecedor',
          beforeEnter: function (to, _, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/fornecedor.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Fornecedor',
                active: true,
              },
            ],
            pageTitle: 'Fornecedor',
            rule: 'editor',
          },
        },
        {
          path: '/tiposFornecedor',
          name: 'Fornecedor',
          beforeEnter: function (to, _, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/tiposFornecedor.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Fornecedor',
                url: '/fornecedor',
              },
              {
                title: 'Tipo de Fornecedor',
                active: true,
              },
            ],
            pageTitle: 'Tipo de Fornecedor',
            checkPermission: true,
            rule: 'editor',
          },
        },
        {
          path: '/classe',
          name: 'Classe',
          beforeEnter: function (to, _, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/classe.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Classe',
                url: '/classe',
              },
              {
                title: 'Classe',
                active: true,
              },
            ],
            pageTitle: 'Classe',
            checkPermission: true,
            rule: 'editor',
          },
        },
        {
          path: '/apolice',
          name: 'Apólice',
          beforeEnter: function (to, _, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/cadastros/apolice.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Apólice',
                active: true,
              },
            ],
            pageTitle: 'Apólice',
            rule: 'editor',
          },
        },
        {
          path: '/agregados',
          name: 'Agregados',
          beforeEnter: function (to, _, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
        },

        // =============================================================================
        // MENU ADMINISTRADOR (CONFIGURAÇÕES)
        // =============================================================================

        {
          path: '/produtos',
          name: 'Produto',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/configuracoes/produtos.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Produtos',
            rule: 'editor',
          },
        },
        {
          path: '/contrato',
          name: 'Contrato',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/configuracoes/contrato.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Contratos',
            rule: 'editor',
          },
        },
        {
          path: '/campanha',
          name: 'Campanha',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/configuracoes/campanha.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Campanhas',
            rule: 'editor',
          },
        },
        {
          path: '/tipoPagamento',
          name: 'Tipo de Pagamento',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/configuracoes/tipoPagamento.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Tipo de Pagamentos',
            rule: 'editor',
          },
        },
        {
          path: '/beneficios',
          name: 'Benefícios / Coberturas',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/configuracoes/beneficios.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Benefícios / Coberturas',
            rule: 'editor',
          },
        },
        {
          path: '/tipoFotos',
          name: 'Tipo de Foto',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/configuracoes/tipoFotos.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Tipo de Fotos',
            rule: 'editor',
          },
        },
        {
          path: '/tipos-arquivos-vistoria',
          name: 'Tipos de Arquivos Vistoria',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Tipos de Arquivos Vistoria',
            rule: 'editor',
          },
        },
        {
          path: '/restricoes',
          name: 'Restrições',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/configuracoes/restricoes.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Restrições',
            rule: 'editor',
          },
        },
        {
          path: '/integracaoSGA',
          name: 'Integração SGA',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/configuracoes/integracaoSGA.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Integração SGA',
            rule: 'editor',
          },
        },
        {
          path: '/integracoes',
          name: 'Integrações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/configuracoes/integracoes.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Integrações',
            rule: 'editor',
          },
        },
        {
          path: '/traducoes',
          name: 'Traduções',
          beforeEnter: function (to, _, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'Traduções',
            rule: 'editor',
          },
        },
        {
          path: '/listIntegracaoDePara/:idIntegracao',
          name: 'De-Para',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/configuracoes/integracaoSGA-dePara.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Configurações',
                active: true,
              },
            ],
            pageTitle: 'De-Para',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/status',
          name: 'Status',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/configuracoes/Status/StatusView.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Status',
                active: true,
              },
            ],
            pageTitle: 'Status',
            rule: 'editor',
          },
        },
        // =============================================================================
        // MENU ADMINISTRADOR (CONFIGURAÇÕES)
        // =============================================================================
        {
          path: '/simulador',
          name: 'Simulador',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/simulador.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Tabelas',
                active: true,
              },
            ],
            pageTitle: 'Simulador',
            rule: 'editor',
          },
        },
        {
          path: '/grupoVeiculos',
          name: 'Grupo de Veículos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/grupoVeiculos.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Grupos',
                active: true,
              },
            ],
            pageTitle: 'Grupo de Veículos',
            rule: 'editor',
          },
        },
        {
          path: '/listGruposModelos/:id',
          name: 'listGruposModelos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/tabelas/grupoVeiculosModelos.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Grupos',
                url: '/grupoVeiculos',
              },
              {
                title: 'Modelos Associados',
                active: true,
              },
            ],
            pageTitle: 'Modelos Associados ao Grupo',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/listGruposAcessorios/:id',
          name: 'listGruposAcessorios',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () =>
            import('./views/menu/tabelas/grupoVeiculosAcessorios.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Grupos',
                url: '/grupoVeiculos',
              },
              {
                title: 'Acessorios Associados',
                active: true,
              },
            ],
            pageTitle: 'Acessorios Associados ao Grupo',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/tabelas',
          name: 'Tabelas',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/tabelas.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Tabelas',
                active: true,
              },
            ],
            pageTitle: 'Tabelas',
            rule: 'editor',
          },
        },
        {
          path: '/listTabelaValores/:id',
          name: 'listTabelaValores',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/valores.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Tabelas',
                url: '/Tabelas',
              },
              {
                title: 'Valores',
                active: true,
              },
            ],
            pageTitle: 'Valores',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/listTabelaEstadosCidades/:id',
          name: 'listTabelaEstadosCidades',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/estadosCidades.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Tabelas',
                url: '/Tabelas',
              },
              {
                title: 'Estados e Cidades',
                active: true,
              },
            ],
            pageTitle: 'Estados e Cidades',
            rule: 'editor',
            checkPermission: false,
          },
        },
        {
          path: '/blackList',
          name: 'Black List',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/blackList.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Tabelas',
                active: true,
              },
            ],
            pageTitle: 'Black List',
            rule: 'editor',
          },
        },
        {
          path: '/listRastreadores',
          name: 'Lista Rastreadores',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/listRastreadores.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Tabelas',
                active: true,
              },
            ],
            pageTitle: 'Lista de Rastreadores',
            rule: 'editor',
          },
        },
        {
          path: '/listParticipacoes',
          name: 'Lista Participações',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./views/menu/tabelas/listParticipacoes.vue'),
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/',
              },
              {
                title: 'Tabelas',
                active: true,
              },
            ],
            pageTitle: 'Lista de Participações',
            rule: 'editor',
          },
        },
        {
          path: '/login-empresa',
          name: 'login-empresa',
          component: () => import('@/views/pages/LoginMultiEmpresa.vue'),
        },
        {
          path: '/update-login-empresa',
          name: 'update-login-empresa',
          component: () => import('@/views/pages/LoginUpdateMultiEmpresa.vue'),
        },
        {
          path: '/401',
          name: 'pageError401',
          component: () => import('@/views/pages/Error401.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/financeiro/projetado',
          name: 'Relatório Projetado',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
        {
          path: '/financeiro/recebido',
          name: 'Relatório Recebido',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('./v2/PageLoader.vue'),
          meta: {
            checkPermission: false,
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/Login',
          name: 'pageLogin',
          component: () => import('@/views/pages/Login.vue'),
        },
        {
          path: '/TrocarSenha',
          name: 'trocaSenha',
          component: () => import('@/views/pages/trocarSenha.vue'),
        },
        {
          path: '/proposta/:chave',
          beforeEnter: function (to, from, next) {
            rotasEmpresas(to, next);
          },
          name: 'proposta',
          component: () => import('@/views/pages/Invoice.vue'),
        },
        {
          path: '/propostas/:chave',
          name: 'propostaBP',
          component: () => import('@/views/pages/Invoice2.vue'),
        },
        {
          path: '/multi-propostas/:chave',
          name: 'multiPropostaBP',
          component: () => import('@/views/pages/InvoiceMulti.vue'),
        },
        {
          path: '/novaProposta/:idEmpresa',
          name: 'novaProposta',
          component: () => import('@/views/pages/novaProposta.vue'),
        },
        {
          path: '/novaProposta/:idEmpresa/:userName',
          name: 'novaPropostaUser',
          component: () => import('@/views/pages/novaProposta.vue'),
        },
        {
          path: '/novaOuvidoria/:idEmpresa',
          name: 'novaOuvidoria',
          component: () => import('@/views/pages/novaOuvidoria.vue'),
        },
        {
          path: '/ChamadoResposta/:idChamado',
          name: 'ChamadoResposta',
          component: () => import('@/views/pages/ChamadoResposta.vue'),
        },
        {
          path: '/admbptech',
          name: 'Painel Administração',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
          component: () => import('@/views/pages/ADMBTX.vue'),
        },
        {
          path: '/admfilas',
          name: 'admfilas',
          component: () => import('@/views/pages/ADMFilas.vue'),
        },
        {
          path: '/admcreditos',
          name: 'Painel Créditos',
          component: () => import('@/views/pages/ADMCreditos.vue'),
          pageTitle: 'Painel Créditos',
          beforeEnter: function (to, from, next) {
            isAuth(to, next);
            maintenance(next);
          },
        },
        {
          path: '/painelAssistencia',
          name: 'painelAssistencia',
          component: () => import('@/views/pages/painelAssistencia.vue'),
        },
        {
          path: '/arquivoImpressao/:idRateio',
          name: 'arquivoImpressao',
          component: () => import('@/views/pages/arquivoImpressaoRateio.vue'),
        },
        {
          path: '/boleto/:idRegistroFinanceiro',
          name: 'boleto',
          component: () => import('@/views/pages/Boleto.vue'),
        },
        {
          path: '/boleto/:idRegistroFinanceiro/:nossoNumero',
          name: 'boleto',
          component: () => import('@/views/pages/Boleto.vue'),
        },
        {
          path: '/cadastroConsultor',
          name: 'cadastroConsultor',
          component: () => import('@/views/forms/FormConsultor.vue'),
        },
        {
          path: '/checklistImpressao/:idChecklist/:motivo',
          name: 'checklistImpressao',
          component: () => import('@/views/pages/ChecklistImpressao.vue'),
        },
        {
          path: '/contratoAdesao/:chave',
          name: 'contratoAdesao',
          component: () => import('@/views/pages/ContratoAdesao.vue'),
        },
        {
          path: '/termoContrato/:idModelo/:chave',
          name: 'termoContrato',
          component: () => import('@/views/pages/TermosDoContrato.vue'),
        },
        {
          path: '/laudoVistoria/:chave',
          name: 'laudoVistoria',
          component: () => import('@/views/pages/LaudoVistoria.vue'),
        },
        {
          path: '/propostasBP/:chave',
          name: 'invoiceBP-3',
          component: () => import('@/views/pages/Invoice3.vue'),
        },
        {
          path: '/landing-page-BP/',
          name: 'landingPageBP',
          component: () => import('@/views/pages/LandingPage.vue'),
        },
        /*{
          path: '/nova-proposta-BP/',
          name: 'novaPropostaBP',
          component: () => import('@/views/pages/FormColetaCEP.vue'),
        },*/
        {
          path: '/chat-bot-BP/',
          name: 'chatBotBP',
          component: () => import('@/views/forms/FormChatNovaProposta.vue'),
        },
        {
          path: '/maintenance',
          name: 'pageMaintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
        },
        {
          path: '/certificadoSeguradora',
          name: 'certificadoSeguradora',
          component: () => import('@/views/pages/CertificadoSeguradora.vue'),
        },
        {
          path: '/eventoPDF/:chave',
          name: 'eventoPDF',
          component: () => import('@/views/pages/EventosView.vue'),
        },
      ],
    },
    // =============================================================================
    // Segunda Via de Boleto
    // =============================================================================
    {
      path: '/segunda-via-boleto/',
      name: 'segundaViaBoleto',
      component: () =>
        import('@/views/pages/SegundaViaBoleto/segundaViaBoleto.vue'),
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404',
    },
  ],
});

function isAuth(to, next) {
  const token = localStorage.getItem('user-token');

  localStorage.setItem('rotaEntrada', window.location.href.toString());
  if (!token) {
    next(`/Login`);
    return;
  } else {
    const decoded = jwt.decode(token);
    if (!decoded) {
      next(`/Login`);
      return;
    } else {
      //confere exp
      if (Date.now() >= decoded.exp * 1000) {
        next(`/Login`);
        return;
      }
    }
  }
  validatePermission(to, next);
}

function maintenance(next) {
  const maintenance = process.env.VUE_APP_MAINTENANCE;

  if (maintenance) {
    next('/maintenance');
  } else {
    next();
  }
}

function verificaDominio(next) {
  const dominio = window.location.href.toString();
  const query = window.location.search;

  if (dominio.indexOf('certificado.bpseguradora') >= 0) {
    next('/certificadoSeguradora' + query);
    return;
  }

  if (dominio.indexOf('cotacao.bemprotege') >= 0) {
    next('/landing-page-BP' + query);
    return;
  }

  next();
}

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

function validatePermission(to, next) {
  if (to.meta.checkPermission != undefined) {
    if (!to.meta.checkPermission) {
      return next();
    }
  }

  const permission = ability.getPermission();

  if (permission.can('Leitura', to.name)) {
    return next();
  }

  next(`/401`);
}

function rotasEmpresas(to, next) {
  var idEmpresa = 0;
  service
    .getAll('CotacaoAberta', null, 'getIdEmpresa/' + to.params.chave)
    .then((res) => {
      idEmpresa = res.data.id_empresa;
      if (functions.verificaEmpresaBemProtege(idEmpresa)) {
        // if (idEmpresa == 120) {
        //   next(`/propostasBP/${to.params.chave}`);
        //   return;
        // }
        //next();
        next(`/propostas/${to.params.chave}`);
      } else next();
    })
    .catch((e) => {
      next(e);
    });
}

export default router;
